// extracted by mini-css-extract-plugin
export default {"errorPage":"styles_errorPage__rrZez","homeLink":"styles_homeLink__Qbaeb"};